import { render, staticRenderFns } from "./myRfq.vue?vue&type=template&id=5f5f1632&scoped=true"
import script from "./myRfq.vue?vue&type=script&lang=js"
export * from "./myRfq.vue?vue&type=script&lang=js"
import style0 from "./myRfq.vue?vue&type=style&index=0&id=5f5f1632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5f1632",
  null
  
)

export default component.exports